import { makeVar } from '@apollo/client'

import { UserFilterCollection } from 'src/hooks/useSavedFilters/__generated__/types'

export type SavedFilter = NonNullable<
  UserFilterCollection['userFilterCollection']
>

export const savedFiltersVar = makeVar<Record<string, SavedFilter[]> | null>(
  null
)
